export const COLORS = {
    primaryButtonBackground: "#333",
    primaryButtonText: "#fff",
    agreementFont: "#338F86",
    greyColor: "#cccccc",
    whiteColor: "#FFFFFF",
    darkGreyColor: "#979797",
  };
  